import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-webhook",
  "use": "app-channel-webhook-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-channel-webhook\"><path d=\"M19.06 12.004l5 5-5 5m-6-10l-5 5 5 5m16.94 7a2 2 0 01-2 2H4a2 2 0 01-2-2v-26a2 2 0 012-2h20.06a2 2 0 011.397.57l3.94 3.842A2 2 0 0130 6.848v22.156z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-webhook.svg
// module id = B0zD
// module chunks = 39 44